// src/components/copilot/components/ChatHeader.jsx
import {
  Assistant,
  Close as CloseIcon,
  Fullscreen,
  FullscreenExit,
  ViewSidebar,
} from "@mui/icons-material";
import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import { memo } from "react";
import Txt from "../../../typography/Txt";

const ChatHeader = memo(({ onClose, displayMode, onCycleDisplayMode }) => {
  const getDisplayModeTooltip = () => {
    switch (displayMode) {
      case "compact":
        return "Expand to full screen";
      case "expanded":
        return "Switch to inline mode";
      case "inline":
        return "Switch to compact mode";
      default:
        return "Change view";
    }
  };

  const getDisplayModeIcon = () => {
    switch (displayMode) {
      case "compact":
        return <Fullscreen />;
      case "expanded":
        return <ViewSidebar />;
      case "inline":
        return <FullscreenExit />;
      default:
        return <Fullscreen />;
    }
  };

  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        borderRadius: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "primary.main",
        color: "white",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Assistant sx={{ color: "#ffffff", fontSize: "28px" }} />
        <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1 }}>
          <Txt fontWeight={500} sx={{ fontSize: "18px" }}>
            Loan Assistant
          </Txt>
          <Txt secondary sx={{ color: "inherit" }}>
            I'm here to help, ask me anything!
          </Txt>
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: 0.5 }}>
        <Tooltip title={getDisplayModeTooltip()} placement="bottom">
          <IconButton
            onClick={onCycleDisplayMode}
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            }}
          >
            {getDisplayModeIcon()}
          </IconButton>
        </Tooltip>

        <Tooltip title="Close" placement="bottom">
          <IconButton
            onClick={onClose}
            sx={{
              color: "white",
              "&:hover": {
                backgroundColor: "primary.dark",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );
});

ChatHeader.displayName = "ChatHeader";

export default ChatHeader;
